import requester from "api/requester"
import { IUserResponse } from "features/onboarding/types"

const notificationAPI = {
  async checkIsUserHasLogThreeMeal(): Promise<boolean> {
    const userInfo: IUserResponse = await requester.get("/users/info")

    return userInfo.showDownload
  },
}

export default notificationAPI
